<template>
  <validation-observer ref="form" tag="div">
    <validation-provider
        v-slot="{ validated, errors }"
        :name="lodash.upperFirst($t('odoo_partners.name'))"
        rules="required"
        vid="is_company"
    >
      <b-form-radio-group
          v-model="model.is_company"
          :label="lodash.upperFirst($t('odoo_partners.type')) + '*'"
      >
        <template v-for="{value,text} in typeOptions">
          <b-form-radio :key="`partner-type-${value}`" :value="value">{{ text }}</b-form-radio>
        </template>
      </b-form-radio-group>
    </validation-provider>
    <validation-provider
        v-slot="{ validated, errors }"
        :name="lodash.upperFirst($t('odoo_partners.name'))"
        rules="required"
        vid="name"
    >
      <b-form-group
          :invalid-feedback="errors[0]"
          :label="lodash.upperFirst($t('odoo_partners.name')) + '*'"
          :state="errors[0] ? false : validated ? true : null"
          class="row mb-3 "
          label-cols-md="12"
      >
        <b-form-input
            id="name"
            v-model="model.name"
            :state="errors[0] ? false : (validated ? true : null)"
            type="text"
        ></b-form-input>
      </b-form-group>
    </validation-provider>
    <validation-provider
        v-if="!model.is_company"
        v-slot="{ validated, errors }"
        :name="lodash.upperFirst($t('odoo_partners.parent_id'))"
        vid="parent_id"
    >
      <b-form-group
          :invalid-feedback="errors[0]"
          :label="lodash.upperFirst($t('odoo_partners.company'))"
          :state="errors[0] ? false : validated ? true : null"
          class="row mb-3 "
          label-cols-md="12"
      >
        <multiselect-ajax
            :key="`${_uid}-company`"
            v-model.number="model.parent_id"
            :custom-label="countryLabel"
            :params="{is_company: 1}"
            :placeholder="lodash.upperFirst($t('odoo_partners.company'))"
            name="company_id"
            url="/odoo/partners"
        />
      </b-form-group>
    </validation-provider>
    <b-form-group :label="lodash.upperFirst($t('odoo_partners.address'))">
      <validation-provider
          v-slot="{ validated, errors }"
          :name="lodash.upperFirst($t('odoo_partners.street'))"
          vid="street"
      >
        <b-form-group
            :invalid-feedback="errors[0]"
            :state="errors[0] ? false : validated ? true : null"
            class="row mb-3"
        >
          <b-form-input
              id="street"
              v-model="model.street"
              :placeholder="lodash.upperFirst($t('odoo_partners.street'))"
              :state="errors[0] ? false : (validated ? true : null)"
              type="text"
          ></b-form-input>
        </b-form-group>
      </validation-provider>
      <validation-provider
          v-slot="{ validated, errors }"
          :name="lodash.upperFirst($t('odoo_partners.street_2'))"
          vid="street_2"
      >
        <b-form-group
            :invalid-feedback="errors[0]"
            :state="errors[0] ? false : validated ? true : null"
            class="row mb-3"
        >
          <b-form-input
              id="street_2"
              v-model="model.street2"
              :placeholder="lodash.upperFirst($t('odoo_partners.street_2'))"
              :state="errors[0] ? false : (validated ? true : null)"
              type="text"
          ></b-form-input>
        </b-form-group>
      </validation-provider>
      <div class="row">
        <validation-provider
            v-slot="{ validated, errors }"
            :name="`${lodash.upperFirst($t('odoo_partners.country'))}*`"
            class="col-6 mb-3"
            rules="required"
            vid="country_id"
        >
          <b-form-group
              :invalid-feedback="errors[0]"
              :state="errors[0] ? false : (validated ? true : null)"
          >
            <multiselect-ajax
                :key="`${_uid}-country`"
                v-model.number="model.country_id"
                :custom-label="countryLabel"
                :placeholder="lodash.upperFirst($t('odoo_partners.country'))"
                name="country_id"
                url="/odoo/countries"
            />
          </b-form-group>
        </validation-provider>
        <validation-provider
            v-slot="{ validated, errors }"
            :name="lodash.upperFirst($t('odoo_partners.state'))"
            class="col-6 mb-3"
            vid="state"
        >
          <b-form-group
              :invalid-feedback="errors[0]"
              :state="errors[0] ? false : (validated ? true : null)"
          >
            <multiselect-ajax
                :key="`${_uid}-${model.country_id}-state`"
                v-model.number="model.state_id"
                :custom-label="stateLabel"
                :disabled="!model.country_id"
                :params="{
                  country_id: model.country_id
                }"
                :placeholder="lodash.upperFirst($t('odoo_partners.state'))"
                name="state_id"
                url="/odoo/states"
            />
          </b-form-group>
        </validation-provider>
        <validation-provider
            v-slot="{ validated, errors }"
            :name="lodash.upperFirst($t('odoo_partners.city'))"
            class="col-6 mb-3"
            vid="city"
        >
          <b-form-group
              :invalid-feedback="errors[0]"
              :state="errors[0] ? false : (validated ? true : null)"
          >
            <b-form-input
                id="city"
                v-model="model.city"
                :placeholder="lodash.upperFirst($t('odoo_partners.city'))"
                :state="errors[0] ? false : (validated ? true : null)"
                type="text"
            ></b-form-input>
          </b-form-group>
        </validation-provider>
        <validation-provider
            v-slot="{ validated, errors }"
            :name="lodash.upperFirst($t('odoo_partners.zip'))"
            class="col-6 mb-3"
            vid="zip"
        >
          <b-form-group
              :invalid-feedback="errors[0]"
              :state="errors[0] ? false : (validated ? true : null)"
          >
            <b-form-input
                id="zip"
                v-model="model.zip"
                :placeholder="lodash.upperFirst($t('odoo_partners.zip'))"
                :state="errors[0] ? false : (validated ? true : null)"
                type="text"
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </div>
    </b-form-group>
    <validation-provider
        v-slot="{ validated, errors }"
        :name="lodash.upperFirst($t('odoo_partners.phone'))"
        vid="phone"
    >
      <b-form-group
          :invalid-feedback="errors[0]"
          :label="lodash.upperFirst($t('odoo_partners.phone'))"
          :state="errors[0] ? false : validated ? true : null"
          class="row mb-3"
      >
        <b-form-input
            id="phone"
            v-model="model.phone"
            :placeholder="lodash.upperFirst($t('odoo_partners.phone'))"
            :state="errors[0] ? false : (validated ? true : null)"
            type="text"
        ></b-form-input>
      </b-form-group>
    </validation-provider>
    <validation-provider
        v-slot="{ validated, errors }"
        :name="lodash.upperFirst($t('odoo_partners.mobile'))"
        vid="mobile"
    >
      <b-form-group
          :invalid-feedback="errors[0]"
          :label="lodash.upperFirst($t('odoo_partners.mobile'))"
          :state="errors[0] ? false : validated ? true : null"
          class="row mb-3"
      >
        <b-form-input
            id="mobile"
            v-model="model.mobile"
            :placeholder="lodash.upperFirst($t('odoo_partners.mobile'))"
            :state="errors[0] ? false : (validated ? true : null)"
            type="text"
        ></b-form-input>
      </b-form-group>
    </validation-provider>
    <validation-provider
        v-slot="{ validated, errors }"
        :name="lodash.upperFirst($t('odoo_partners.email'))"
        vid="email"
        rules="email"
    >
      <b-form-group
          :invalid-feedback="errors[0]"
          :label="lodash.upperFirst($t('odoo_partners.email'))"
          :state="errors[0] ? false : validated ? true : null"
          class="row mb-3"
      >
        <b-form-input
            id="email"
            v-model="model.email"
            :placeholder="lodash.upperFirst($t('odoo_partners.email'))"
            :state="errors[0] ? false : (validated ? true : null)"
            type="email"
        ></b-form-input>
      </b-form-group>
    </validation-provider>
    <validation-provider
        v-slot="{ validated, errors }"
        :name="lodash.upperFirst($t('odoo_partners.website'))"
        vid="website"
    >
      <b-form-group
          :invalid-feedback="errors[0]"
          :label="lodash.upperFirst($t('odoo_partners.website'))"
          :state="errors[0] ? false : validated ? true : null"
          class="row mb-3"
      >
        <b-form-input
            id="website"
            v-model="model.website"
            :placeholder="lodash.upperFirst($t('odoo_partners.website'))"
            :state="errors[0] ? false : (validated ? true : null)"
            type="website"
        ></b-form-input>
      </b-form-group>
    </validation-provider>
  </validation-observer>
</template>

<script>
import FormModel from "./model";

export default {
  extends: FormModel,
  data() {
    return {
      model: {
        is_company: true,
        ...this.value,
      },
      typeOptions: [
        {value: false, text: this.lodash.upperFirst(this.$t('odoo_partners.individual'))},
        {value: true, text: this.lodash.upperFirst(this.$t('odoo_partners.company'))}
      ]
    };
  },
  methods: {
    countryLabel({name}) {
      return `${name}`
    },
    stateLabel({name}) {
      return `${name}`
    },
  },
};
</script>
